import React from 'react';
import Styles from './address-styles.scss';
import { InputKVBase } from '@/presentation/components';
import { useRecoilState } from 'recoil';
import { signUpState } from '../atoms';
import CountryStateCity from '@/presentation/components/country-state-city/country-state-city';
const Address = ({ manageCountriesStateCities }) => {
    const [state, setState] = useRecoilState(signUpState);
    const handleDataChange = (data) => {
        setState(prev => (Object.assign(Object.assign({}, prev), { idCountry: data === null || data === void 0 ? void 0 : data.idCountry, idState: data === null || data === void 0 ? void 0 : data.idState, idCity: data === null || data === void 0 ? void 0 : data.idCity })));
    };
    return (React.createElement("div", { className: Styles.addressWrap },
        React.createElement("div", { className: Styles.row },
            React.createElement(InputKVBase, { type: "text", name: "address", placeholder: "ie. 102 Green St.", label: "ADDRESS", state: state, setState: setState, required: true }),
            React.createElement(InputKVBase, { type: "text", name: "addressLine2", placeholder: "ie. office number etc.", label: "ADDRESS LINE 2", state: state, setState: setState })),
        React.createElement("div", { className: Styles.customAddressWrap },
            React.createElement(CountryStateCity, { manageCountriesStateCities: manageCountriesStateCities, handleDataChange: handleDataChange, customStyles: {
                    classCountryWrap: Styles.classCountryWrap,
                    classStateWrap: Styles.classStateWrap,
                    classCityWrap: Styles.classCityWrap
                } })),
        React.createElement("div", { className: Styles.addressLine2 },
            React.createElement(InputKVBase, { type: "text", name: "addressZip", placeholder: "ie. 33592", label: "ZIP/POSTAL CODE", state: state, setState: setState, required: true }))));
};
export default Address;
